import React from "react";
import Reveal from "../site/Reveal";
import { SectionLabel, ArrowLink } from "../site/Bits";
import { WHO_WE_ARE } from "../../lib/content";
import { IMAGES } from "../../lib/images";

export default function WhoWeAre() {
  return (
    <section className="lk-section" data-testid="who-we-are-section" id="who-we-are">
      <div className="lk-container-wide">
        <div className="grid gap-y-9 lg:grid-cols-12 lg:gap-x-16">
          <div className="lg:col-span-6">
            <Reveal>
              <SectionLabel>Who We Are</SectionLabel>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="display-lg mt-5">
                {WHO_WE_ARE.heading.map((line, i) => (
                  <span key={line} className="block" style={i === 1 ? { color: "#352A59" } : undefined}>
                    {line}
                  </span>
                ))}
              </h2>
            </Reveal>
          </div>

          <div
            className="lg:col-span-5 lg:col-start-8 lg:border-l lg:pl-14"
            style={{ borderColor: "rgba(216,183,122,0.4)" }}
          >
            <div className="space-y-6">
              {WHO_WE_ARE.body.map((paragraph, i) => (
                <Reveal key={paragraph} delay={0.1 + i * 0.07}>
                  <p className="lead measure">{paragraph}</p>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.34}>
              <div className="mt-8">
                <ArrowLink to={WHO_WE_ARE.cta.to} data-testid="who-we-are-discover-lykit-cta">
                  {WHO_WE_ARE.cta.label}
                </ArrowLink>
              </div>
            </Reveal>
          </div>
        </div>
      </div>

      {/* full-width editorial banner below the copy */}
      <div className="mt-[clamp(30px,3vw,52px)] overflow-hidden">
        <Reveal variant="image">
          <div
            className="img-frame relative w-full"
            style={{ aspectRatio: "16 / 7", background: "transparent" }}
          >
            <img
              src={IMAGES.whoWeAre}
              alt="The LYKIT ecosystem: live events, advertising, digital entertainment, post-production and social impact"
              data-testid="who-we-are-banner"
              loading="lazy"
              style={{ objectPosition: "center" }}
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
